const breakpoints = {
  desktopLarge: 1900, // large monitors
  desktopMid: 1440, // full HD and up
  desktopSmall: 1200, // common laptop width
  desktopToMobile: 990, // width in which the layout changes from desktop to mobile (small laptops and landscape tablets)
  mobileLarge: 750, // portrait tablets (iPad Mini etc)
  mobileMid: 600, // large phones
  mobileSmall: 450, // typical smartphones in portrait
  mobileSmaller: 360 // very small devices
}

export default breakpoints
